import moment from 'moment-timezone';

// Owner rule (A-52): session pages show no payment details; they link to the class's teacher-month on
// the Penalties tab instead. The tab has no per-session filter, so teacher + IST pay month is the
// narrowest existing deep link (?month=YYYY-MM&teacher=<uuid>).
export function session_penalties_url({ teacher_uuid, epoch_start_time }) {
  const qs = new URLSearchParams();
  const start = Number(epoch_start_time);
  if (Number.isFinite(start) && start > 0) {
    qs.set('month', moment(start).tz('Asia/Kolkata').format('YYYY-MM'));
  }
  const teacher = String(teacher_uuid || '').trim();
  if (teacher) qs.set('teacher', teacher);
  const query = qs.toString();
  return `/teacher-payments/penalties${query ? `?${query}` : ''}`;
}
